__turbopack_context__.v({
  "progress": "emailHandoffProgress-module-scss-module__XByeZG__progress",
});
